/* KES: keep the shopper's place on collection pages.
   1. Back from a product restores the pages loaded with Load More and the scroll position.
   2. Back after changing a filter shows the earlier filter state (the facets push the URL but
      never handled Back, so the page kept showing the newer results).
   Passive: no DOM writes of its own; it clicks the existing Load More control and scrolls. */
(function () {
  if (window.__kesCollState) return;
  window.__kesCollState = true;
  var KEY = 'kes:coll:' + location.pathname + location.search;
  function store(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }
  function grid() { return document.querySelector('[ref="grid"]'); }
  function pageNow() {
    var lm = document.querySelector('load-more-list'), g = grid();
    return Number((lm && lm.dataset.currentPage) || (g && g.dataset.currentPage) || 1);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a || !a.closest('[ref="grid"]')) return;
    store(function (s) { s.setItem(KEY, JSON.stringify({ p: pageNow(), y: window.scrollY, t: Date.now() })); });
  }, true);
  function restore() {
    var saved = store(function (s) { return JSON.parse(s.getItem(KEY) || 'null'); });
    store(function (s) { s.removeItem(KEY); });
    if (!saved || Date.now() - saved.t > 30 * 60 * 1000) return;
    var tries = 0;
    (function step() {
      var btn = document.querySelector('load-more-list [ref="loadMoreButton"]');
      if (pageNow() >= saved.p || !btn || btn.hidden || ++tries > 40) { window.scrollTo(0, saved.y); return; }
      document.addEventListener('loadMoreEvent', function once() {
        document.removeEventListener('loadMoreEvent', once);
        setTimeout(step, 0);
      });
      btn.click();
    })();
  }
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  if (nav.type === 'back_forward') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) store(function (s) { s.removeItem(KEY); }); });
  var shown = location.search, push = history.pushState, rep = history.replaceState;
  history.pushState = function () { var r = push.apply(this, arguments); shown = location.search; return r; };
  history.replaceState = function () { var r = rep.apply(this, arguments); shown = location.search; return r; };
  window.addEventListener('popstate', function () { if (location.search !== shown) location.reload(); });
})();
